import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXray = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 8.50879L16.2002 12L21 15.4912V23L12 16.25L3 23V15.5195L3.375 15.2188L7.39844 12L3.375 8.78125L3 8.48047V1L12 7.75098L21 1V8.50879ZM12 10.25V13.75L19 19.001V16.5088L12.7998 12L19 7.49121V4.99902L12 10.25Z",
			fill: "currentColor"
		})
	]
});
export default SvgXray;
